import TranslatesContent from "../../DataStore/Languages/translatesContent";

const ImportantNotice = () => {
  return (
    <div className="col-12 mt-3 mb-3">
      <span style={{ color: "#d64e4e", fontSize: "14px", fontWeight: "300" }}>
        <TranslatesContent contentKey="important-notes" />
      </span>
      <span style={{ fontSize: "14px", fontWeight: "100" }}>
        <TranslatesContent contentKey="important-notice-content" />
        {/* <ul>
            <li>Deposits are
                subjected to a 1x wagering requirement.
            </li>
            <li>Please always deposit to the latest bank shown on
                this page. If you deposit money into an old bank
                account and cause any delayed or lost, we will not
                be responsible.</li>
        </ul> */}
      </span>
    </div>
  );
};

export default ImportantNotice;
